// extracted by mini-css-extract-plugin
module.exports = {"amit":"Footer_amit__N1Zcu"};